import AuthorizationBrowserFirstParty, { config } from "@webex/plugin-authorization-browser-first-party";
import WebexCore from "@webex/webex-core";
import merge from "lodash/merge";
import "webex";
WebexCore.registerPlugin("authorization", AuthorizationBrowserFirstParty, {
    config,
    proxies: ["isAuthorizing", "isAuthenticating"],
    replace: true
});
const Webex = WebexCore.extend({
    webex: true
});
Webex.init = function init(attrs) {
    attrs.config = merge({
        sdkType: "webex"
    }, attrs.config);
    return new Webex(attrs);
};
export default Webex;
